import { useRequestsHandlerData } from '../../../../../hooks/useRequestsHandlerData';
import { GTMSignUp } from '../../../../../constants/analytics/GTM';
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import { useEffect } from 'react';
import useToNextState from './useToNextState';
import { useRequests } from '../../../../../redux/reducer/requests';
import { useContent } from '../../../../../redux/reducer/content';
import { useModal } from '../../../../../hooks/useModal';
import { useSharePreloadPromises } from './useSharePreloadPromises';

export default function useShareLogic() {
  const { authData } = useRequests();
  const { viewedFriend } = useContent();
  const { addModal } = useModal();

  const callbacks = useApplicationCallbacks();
  const preloadPromises = useSharePreloadPromises();
  const toNextState = useToNextState();

  useRequestsHandlerData([
    {
      address: 'requestsGameGetIndex',
      fulfilled: callbacks.getShopItems,
    },
    {
      address: 'requestsShopShopItems',
      settled() {
        callbacks.getFriend(authData?.share);
      },
    },
    {
      address: 'requestsUserGetFriend',
      rejected: toNextState,
    },
    {
      address: 'requestsUserAuth',
      fulfilled(payload) {
        if (payload?.isGameStopped) {
          addModal({
            type: 'inactiveAppModal',
          });
        } else {
          const { profile: userProfile } = payload;
          GTMSignUp();
          userProfile?.uid === viewedFriend?.uid ? toNextState() : preloadPromises();
        }
      },
    },
  ]);

  useEffect(() => {
    if (authData?.share) callbacks.getIndex();
  }, [authData]);
}
